import { memo } from 'react';
import { PH } from '../components/shared';

export const PageComingSoon = memo(({ icon = "🚀", title = "Coming Soon", subtitle = "" }) => {
  return (
    <div className="pg fi">
      <PH eyebrow="Platform" title={title} sub={subtitle} />
      <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:"80px 20px",textAlign:"center"}}>
        <div style={{width:80,height:80,borderRadius:22,background:"rgba(100,116,139,.08)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:36,marginBottom:20}}>{icon}</div>
        <div style={{fontSize:22,fontWeight:700,color:"var(--t1)",marginBottom:8,fontFamily:"var(--fd)"}}>Coming Soon</div>
        <div style={{fontSize:13.5,color:"var(--t3)",lineHeight:1.7,maxWidth:360}}>
          This feature is currently under development. Stay tuned for updates.
        </div>
      </div>
    </div>
  );
});
